var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line 7"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 1.50006,
    x2: 19.4201,
    y2: 1.50006,
    stroke: "#FF8C0B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.50006,
    x2: 19.4201,
    y2: 1.50006,
    stroke: "#FEFEFE",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line 8"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -0.000244141,
    y1: 7.63287,
    x2: 19.4198,
    y2: 7.63287,
    stroke: "#FF8C0B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.000244141,
    y1: 7.63287,
    x2: 19.4198,
    y2: 7.63287,
    stroke: "#FEFEFE",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line 9"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -0.000244141,
    y1: 13.7654,
    x2: 19.4198,
    y2: 13.7654,
    stroke: "#FF8C0B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.000244141,
    y1: 13.7654,
    x2: 19.4198,
    y2: 13.7654,
    stroke: "#FEFEFE",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.460a7270c83d5cbaf69f0ce8d12a7b77.svg";
export { ForwardRef as ReactComponent };